import { motion } from "framer-motion";
import { fmtNum } from "../lib/api";

export const LiveNumber = ({ value, testid, className = "" }) => (
  <motion.span
    key={value ?? 0}
    data-testid={testid}
    initial={{ opacity: 0.4, y: -4 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.4 }}
    className={`inline-block tabular-nums ${className}`}
  >
    {fmtNum(value ?? 0)}
  </motion.span>
);

export const LiveDot = ({ label, testid }) => (
  <span data-testid={testid} className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-[#1FD1FF]">
    <span className="relative flex w-2 h-2">
      <span className="absolute inset-0 rounded-full bg-[#1FD1FF] animate-ping opacity-70" />
      <span className="relative w-2 h-2 rounded-full bg-[#1FD1FF]" />
    </span>
    {label}
  </span>
);
